import constants from "../../constants";
import { useParams } from "react-router-dom";
import { getDataFromStorage, sanitizeName } from "../../util";
import AngleLeftSvg from "../../Svg/AngleLeftSvg";
import AngleRightSvg from "../../Svg/AngleRightSvg";
import LeetCode from "../CommonComponents/LeetCode";
import React, { useEffect, useState } from "react";
// import AlertContext from "../../context/AlertContext";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import ProfileUser from "../CommonComponents/ProfileUser";
import { ProfileProvider } from "../../context/ProfileContext";
// import { UserReportContext } from "../../context/UserReportContext";
// import UserReportHooks from "../../Hooks/UserReport/UserReportHooks";
// import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
// import UserTimeSpentReport from "./UserTimeSpentReport/UserTimeSpentReport";
import UserTestResultReportTable from "./UserTestResultReport/UserTestResultReportTable";
import CodingChallengeReport from "../Admin/Batch/DashboardReports/CodingChallengeReport";
import MockTestReport from "../Admin/Batch/DashboardReports/MockTestReport";
import UserActivityReport from "./UserActivityReport/UserActivityReport";
import Tabs from "../CommonComponents/Tabs";
import { useMemo } from "react";
import InputDropdown from "../CommonComponents/InputDropdown";
import TabList from "../CommonComponents/TabList";
import Tab from "../CommonComponents/Tab";
import TabPanel from "../CommonComponents/TabPanel";
import Drawer from "../CommonComponents/Drawer";
import TabPanels from "../CommonComponents/TabPanels";

// export function UserReport({ onClose }) {
//   const Alert = useContext(AlertContext);
//   const UserReportCxt = useContext(UserReportContext);

//   const axios = useAxiosPrivate();
//   const UserReportHks = UserReportHooks();
//   const useCommonFunctionHks = useCommonFunctionHooks();

//   const { id } = useParams();
//   const { pathname } = useLocation();

//   const navItems = useMemo(
//     () => [
//       {
//         key: "profile",
//         label: "Profile",
//         roles: [constants.Roles.hr, constants.Roles.tutor],
//         content: (
//           <ProfileProvider>
//             <ProfileUser
//               learnerId={UserReportCxt.currentLearnerDetails.value}
//             />
//           </ProfileProvider>
//         ),
//       },
//       {
//         key: "testresults",
//         label: "Test Points",
//         content: <UserTestResultReportTable />,
//       },
//       { key: "activity", label: "Activity", content: <UserActivityReport /> },
//       {
//         key: "competitiveskill",
//         label: "Competitive Skills",
//         content: (
//           <CodingChallengeReport
//             learnerId={UserReportCxt.currentLearnerDetails.value}
//             className={"activitypage"}
//           />
//         ),
//       },
//       {
//         key: "mocktest",
//         label: "Mock Tests",
//         content: (
//           <MockTestReport
//             learnerId={UserReportCxt.currentLearnerDetails.value}
//             className={"activitypage"}
//             fromPage="activitypage"
//           />
//         ),
//       },
//       { key: "cc", label: "Coding Challenge", content: <LeetCode /> },
//       //  { key: "timespent", label: "Time Spent" },
//     ],
//     [],
//   );

//   useEffect(() => {
//     if (
//       !UserReportCxt.currentLearnerDetails.hasOwnProperty("ind") &&
//       UserReportCxt.learnerList.length > 0 &&
//       pathname.includes("users")
//     ) {
//       const cell = UserReportCxt.learnerList[0];
//       UserReportCxt.setCurrentLearnerDetails({
//         ind: cell?.ind,
//         value: cell?.value,
//         label: cell?.label,
//       });
//     }
//   }, [UserReportCxt.learnerList]);
//   useEffect(() => {
//     if (
//       Alert.showBreadCrumbsData?.from === "user" &&
//       UserReportCxt.currentLearnerDetails.value === 0
//     ) {
//       UserReportCxt.setCurrentLearnerDetails({
//         ind: Alert.showBreadCrumbsData.index,
//         value: Alert.showBreadCrumbsData.learnerId,
//         label: Alert.showBreadCrumbsData.studentName,
//       });
//     }

//     const fetchLearnerDetails = async () => {
//       let res = await axios.get(
//         `node/admin/getemails/2/${id}`,
//         useCommonFunctionHks.getHeaderDetailsForAxios(),
//       );

//       let learnerDetails = res.data.data
//         .sort((a, b) => a.firstname.localeCompare(b.firstname))
//         .map((i, index) => {
//           return {
//             ind: index,
//             value: i.id,
//             label: i.firstname + " " + i.lastname,
//           };
//         });

//       UserReportCxt.setLearnerList(learnerDetails);
//     };

//     fetchLearnerDetails();
//     UserReportCxt.setShowPage("profile");
//   }, []);

//   const userRole = getDataFromStorage("role");
//   const filteredNavItems = navItems.filter(
//     (item) => !item.roles || !item.roles.includes(userRole),
//   );
//   console.log("filteredNavItems", filteredNavItems);
//   console.log("UserReportCxt.current:", UserReportCxt?.currentLearnerDetails);
//   console.log("UserReportCxt:", UserReportCxt?.learnerList);

//   return (
//     <div className="user-report-container">
//       {/* {Alert.isLoaded && <Loading />} */}
//     </div>
//   );
// }

export const UserReportHeaderAction = ({
  learners,
  currentLearner,
  onSelect,
}) => {
  const currentIndex = useMemo(
    () => learners.findIndex((item) => item.value === currentLearner),
    [currentLearner, learners],
  );
  const goPrev = () =>
    currentIndex > 0 && onSelect(learners[currentIndex - 1].value);
  const goNext = () =>
    currentIndex < learners.length - 1 &&
    onSelect(learners[currentIndex + 1].value);
  const onChangeLearner = (value) => {
    console.log("setCurrentLearnerId", value);

    onSelect?.(value);
  };
  return (
    <div className="user-report-header-section">
      <AngleLeftSvg disabled={currentIndex === 0} handleFunction={goPrev} />
      <InputDropdown
        placeholder="Select the learner"
        className="user-report-dropdown"
        options={learners || []}
        searchable
        value={currentLearner}
        onChange={onChangeLearner}
      />
      <AngleRightSvg
        disabled={currentIndex === learners.length - 1}
        handleFunction={goNext}
      />
    </div>
  );
};

const UserReportDrawer = ({ open, onClose, learnerId = null }) => {
  const axios = useAxiosPrivate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("profile");
  const [learners, setLearners] = useState([]);
  const [currentLearnerId, setCurrentLearnerId] = useState(learnerId);

  console.log("currentLearnerId", currentLearnerId, "learnerId", learnerId);

  const navItems = useMemo(
    () => [
      {
        key: "profile",
        label: "Profile",
        roles: [constants.Roles.hr, constants.Roles.tutor],
      },
      {
        key: "testresults",
        label: "Test Points",
      },
      { key: "activity", label: "Activity" },
      {
        key: "competitiveskill",
        label: "Competitive Skills",
      },
      {
        key: "mocktest",
        label: "Mock Tests",
      },
      {
        key: "cc",
        label: "Coding Challenge",
      },
    ],
    [],
  );
  const userRole = getDataFromStorage("role");
  const filteredNavItems = useMemo(
    () =>
      navItems.filter((item) => !item.roles || !item.roles.includes(userRole)),
    [navItems, userRole],
  );

  useEffect(() => {
    setCurrentLearnerId(learnerId);
  }, [learnerId]);

  useEffect(() => {
    const fetchLearnerDetails = async () => {
      try {
        let res = await axios.get(`node/admin/getemails/2/${id}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("res.data", res.data);

        let learnerDetails = res.data.data
          .sort((a, b) => a.firstname.localeCompare(b.firstname))
          .map((i, index) => {
            return {
              ind: index,
              value: i.id,
              label: `${sanitizeName(i.firstname)}${
                sanitizeName(i.lastname) ? ` ${sanitizeName(i.lastname)}` : ""
              }`,
            };
          });
        setLearners(learnerDetails);
      } catch (error) {
        console.error(error);
      }
    };

    fetchLearnerDetails();
  }, [axios, id]);
  if(!open) return null

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="bottom"
      width="95vh"
      className="user-report-drawer"
      title={
        <Tabs
          value={activeTab}
          onChange={setActiveTab}
          className="user-report-tabs-container"
        >
          <TabList aria-label="user-report-tab-list">
            {filteredNavItems.map((item) => (
              <Tab key={item.key} value={item.key}>
                {item.label}
              </Tab>
            ))}
          </TabList>
        </Tabs>
      }
      headerActions={
        <UserReportHeaderAction
          learners={learners}
          currentLearner={currentLearnerId}
          onSelect={setCurrentLearnerId}
        />
      }
    >
      <Tabs value={activeTab} onChange={setActiveTab}>
        <TabPanels className="user-report-tab-panels">
          <TabPanel value="profile">
            <ProfileProvider>
              <ProfileUser
                key={currentLearnerId}
                learnerId={currentLearnerId}
              />
            </ProfileProvider>
          </TabPanel>
          <TabPanel value="testresults">
            <UserTestResultReportTable
              key={currentLearnerId}
              learnerId={currentLearnerId}
            />
          </TabPanel>
          <TabPanel value="activity">
            <UserActivityReport
              key={currentLearnerId}
              learnerid={currentLearnerId}
            />
          </TabPanel>
          <TabPanel value="competitiveskill">
            <LeetCode key={currentLearnerId} learnerId={currentLearnerId} />
          </TabPanel>
          <TabPanel value="mocktest">
            <MockTestReport
              key={currentLearnerId}
              learnerId={currentLearnerId}
              className={"activitypage"}
              fromPage="activitypage"
            />
          </TabPanel>
          <TabPanel value="cc">
            <CodingChallengeReport
              key={currentLearnerId}
              learnerId={currentLearnerId}
              className={"activitypage"}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Drawer>
  );
};

export default UserReportDrawer;
